import { Component, input, linkedSignal, output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { UiSliderComponent } from '@app/shared/ui/slider/ui-slider.component';
import { ProffeoUiDensity } from '@app/shared/ui/types/ui.types';
import { formatPercentageValue } from '@app/shared/utils/percentage-format.util';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @summary Task progress control — same behaviour at every density, only the presentation changes.
 * `comfortable` renders the progress slider inline; `compact` renders just the percentage, which opens
 * a panel with the full slider on click.
 * @selector proffeo-task-progress-select
 */
@Component({
  selector: 'proffeo-task-progress-select',
  imports: [MatMenuModule, MatTooltip, TranslatePipe, UiSliderComponent],
  templateUrl: './task-progress-select.component.html',
  styleUrl: './task-progress-select.component.css',
  host: { class: 'inline-flex' }
})
export class TaskProgressSelectComponent {
  protected readonly formatPercent = formatPercentageValue;
  /** Shown value; follows the input and updates right away when the user commits a new value. */
  protected readonly selectedProgress = linkedSignal(() => this.progress());

  /** @summary Completion percentage (0–100). */
  public readonly progress = input.required<number>();
  /** @summary Disables changing the value. */
  public readonly readonly = input<boolean>(false);
  /** @summary `comfortable` = inline slider, `compact` = percentage that opens the slider. */
  public readonly density = input<ProffeoUiDensity>('comfortable');

  /** @summary Emitted when the user commits a new percentage. */
  public readonly progressChange = output<number>();

  protected onProgressChange(progress: number): void {
    if (progress === this.selectedProgress()) {
      return;
    }

    this.selectedProgress.set(progress);
    this.progressChange.emit(progress);
  }
}
